<template>
    <div class="border border-dark rounded-md p-6 mb-5">
        <div class="text-xl leading-6 flex gap-4 flex-col xl:flex-row xl:gap-12 xl:justify-between">
            <slot name="data"></slot>
            <!--
            <div>
                <p class="text-2xl leading-6 font-bold mb-2">{{ name }}</p>
                <p>Created: {{ date }}</p>
            </div>
            <div>
                <p>Started: 0/0 invited, 0 additional</p>
                <p>Finished: 0/0 invited, 0 additional</p>
                <p class="font-bold">Respondent slots: 0 used/0 purchased, 0 available</p>
            </div>
            <div class="xl:text-right">
                <p class="text-2xl">{{ surveyType }}</p>
            </div>
            -->
        </div>
        <div class="flex flex-col items-start lg:flex-row lg:items-center flex-wrap mt-6 gap-x-7 gap-y-4">
            <slot name="actions"></slot>
            <!--
            <button class="flex items-center font-bold text-lg leading-6">
                <svg class="mr-2 w-6 h-6" fill="dark" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512">
                    <path d="M505 442.7L405.3 343c-4.5-4.5-10.6-7-17-7H372c27.6-35.3 44-79.7 44-128C416 93.1 322.9 0 208 0S0 93.1 0 208s93.1 208 208 208c48.3 0 92.7-16.4 128-44v16.3c0 6.4 2.5 12.5 7 17l99.7 99.7c9.4 9.4 24.6 9.4 33.9 0l28.3-28.3c9.4-9.4 9.4-24.6.1-34zM208 336c-70.7 0-128-57.2-128-128 0-70.7 57.2-128 128-128 70.7 0 128 57.2 128 128 0 70.7-57.2 128-128 128z"/>
                </svg>
                Preview survey
            </button>
            <button class="flex items-center font-bold text-lg leading-6">
                <svg class="mr-2 w-6 h-6" fill="dark" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 448 512">
                    <path d="M320 448v40c0 13.255-10.745 24-24 24H24c-13.255 0-24-10.745-24-24V120c0-13.255 10.745-24 24-24h72v296c0 30.879 25.121 56 56 56h168zm0-344V0H152c-13.255 0-24 10.745-24 24v368c0 13.255 10.745 24 24 24h272c13.255 0 24-10.745 24-24V128H344c-13.2 0-24-10.8-24-24zm120.971-31.029L375.029 7.029A24 24 0 0 0 358.059 0H352v96h96v-6.059a24 24 0 0 0-7.029-16.97z"/>
                </svg>
                Copy survey URL
            </button>
            <button class="flex items-center font-bold text-lg leading-6">
                <svg class="mr-2 w-6 h-6" fill="dark" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 384 512">
                    <path d="M336 64h-80c0-35.3-28.7-64-64-64s-64 28.7-64 64H48C21.5 64 0 85.5 0 112v352c0 26.5 21.5 48 48 48h288c26.5 0 48-21.5 48-48V112c0-26.5-21.5-48-48-48zM192 40c13.3 0 24 10.7 24 24s-10.7 24-24 24-24-10.7-24-24 10.7-24 24-24zm121.2 231.8l-143 141.8c-4.7 4.7-12.3 4.6-17-.1l-82.6-83.3c-4.7-4.7-4.6-12.3.1-17L99.1 285c4.7-4.7 12.3-4.6 17 .1l46 46.4 106-105.2c4.7-4.7 12.3-4.6 17 .1l28.2 28.4c4.7 4.8 4.6 12.3-.1 17z"/>
                </svg>
                Survey details
            </button>
            <button class="flex items-center font-bold text-lg leading-6">
                <svg class="mr-2 w-6 h-6" fill="dark" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 352 512">
                    <path d="M242.72 256l100.07-100.07c12.28-12.28 12.28-32.19 0-44.48l-22.24-22.24c-12.28-12.28-32.19-12.28-44.48 0L176 189.28 75.93 89.21c-12.28-12.28-32.19-12.28-44.48 0L9.21 111.45c-12.28 12.28-12.28 32.19 0 44.48L109.28 256 9.21 356.07c-12.28 12.28-12.28 32.19 0 44.48l22.24 22.24c12.28 12.28 32.2 12.28 44.48 0L176 322.72l100.07 100.07c12.28 12.28 32.2 12.28 44.48 0l22.24-22.24c12.28-12.28 12.28-32.19 0-44.48L242.72 256z"/>
                </svg>
                Close Survey
            </button>
            <button class="flex items-center font-bold text-lg leading-6">
                <svg class="mr-2 w-6 h-6" fill="dark" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 576 512">
                    <path d="M528.12 301.319l47.273-208C578.806 78.301 567.391 64 551.99 64H159.208l-9.166-44.81C147.758 8.021 137.93 0 126.529 0H24C10.745 0 0 10.745 0 24v16c0 13.255 10.745 24 24 24h69.883l70.248 343.435C147.325 417.1 136 435.222 136 456c0 30.928 25.072 56 56 56s56-25.072 56-56c0-15.674-6.447-29.835-16.824-40h209.647C430.447 426.165 424 440.326 424 456c0 30.928 25.072 56 56 56s56-25.072 56-56c0-22.172-12.888-41.332-31.579-50.405l5.517-24.276c3.413-15.018-8.002-29.319-23.403-29.319H218.117l-6.545-32h293.145c11.206 0 20.92-7.754 23.403-18.681z"/>
                </svg>
                Buy credits
            </button>
            <button class="flex items-center font-bold text-lg leading-6">
                <svg class="mr-2 w-6 h-6" fill="dark" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 448 512">
                    <path d="M432 32H312l-9.4-18.7A24 24 0 0 0 281.1 0H166.8a23.72 23.72 0 0 0-21.4 13.3L136 32H16A16 16 0 0 0 0 48v32a16 16 0 0 0 16 16h416a16 16 0 0 0 16-16V48a16 16 0 0 0-16-16zM53.2 467a48 48 0 0 0 47.9 45h245.8a48 48 0 0 0 47.9-45L416 128H32z"/>
                </svg>
                Delete survey
            </button>
            <button class="flex items-center font-bold text-lg leading-6 ml-auto">
                View survey
                <svg class="ml-2 w-6 h-6" fill="dark" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 448 512">
                    <path d="M190.5 66.9l22.2-22.2c9.4-9.4 24.6-9.4 33.9 0L441 239c9.4 9.4 9.4 24.6 0 33.9L246.6 467.3c-9.4 9.4-24.6 9.4-33.9 0l-22.2-22.2c-9.5-9.5-9.3-25 .4-34.3L311.4 296H24c-13.3 0-24-10.7-24-24v-32c0-13.3 10.7-24 24-24h287.4L190.9 101.2c-9.8-9.3-10-24.8-.4-34.3z"/>
                </svg>
            </button>
            -->
        </div>
    </div>
</template>

<script>
import Pill from "@/Jetstream/Pill";

export default {
    name: "SurveyCard",
    components: {
        Pill,
    },
    props: {
        surveyType: {
            type: String,
            required: false,
        },
        name: {
            type: String,
            required: false
        },
        date: {
            type: String,
            required: false
        },
        status: {
            type: String,
            required: false,
        },
        statusType: {
            type: String,
            required: false,
        },
    },
    computed: {
        colorClasses() {
            switch (this.statusType) {
                case 'success':
                    return 'bg-green-900';
                case 'warning':
                    return 'bg-orange-900';
                case 'danger':
                    return 'bg-red-900';
                default:
                    return 'text-black bg-gray-100';
            }
        },
    },
}
</script>

<style scoped>

</style>
